import * as Yup from 'yup';

const requiredMessage = `This field is required`;

export const LoginFormValidationSchema = () => {
  const fields: any = {
    username: Yup.string().trim().required(requiredMessage).nullable(),
    password: Yup.string().trim().required(requiredMessage).nullable(),
  };

  return Yup.object().shape(fields);
};

export const ForgotPasswordValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
});
